import { createContext } from "react";
import {
    CommonStore,
} from '../index';

// Create a singleton instance that persists across re-renders
const commonStore = new CommonStore();

export const storesContext = createContext({
    commonStore,
});
